<template>
    <div class="profile">
        <Header/>
        <div class="profile-wrapper">
            <left-panel class="left-panel" @changeComponet="changeComponet" />
            <div class="profile-content">
                <component :is="currentCom" />
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import LeftPanel from './leftPanel';
import adultEdu from './components/adultEdu.vue';
import learningEdu from './components/learningEdu.vue';
import ApplyExam from './components/applyExam.vue';
import Credit from './components/credit.vue';
import InputFace from './components/inputFace.vue';
import Payments from './components/payments.vue';
import ApplyBill from './components/applyBill.vue';
import ChangePsd from './components/changePsd.vue';

export default {
    components: {
        'left-panel': LeftPanel,
        adultEdu,
        learningEdu,
        ApplyExam,
        Credit,
        InputFace,
        Payments,
        ApplyBill,
        ChangePsd
    },
    data(){
        return {
            currentCom: 'learningEdu'
        }
    },
    mounted(){
    },
    methods:{
        changeComponet(name){
            console.log(name,'name')
            this.currentCom = name;
        }
    }
};
</script>

<style lang="scss" scoped>
.profile {
    width: 100%;
    height: 100vh;

    background: #F0F0F0;
    &-wrapper{
        width:1120px;
        position: relative;
        margin: 0 auto;
        display: flex;
        align-items: stretch;
        background: #F0F0F0;
    }
    .left-panel {
        position: relative;
    }
    .profile-content {
        top: 10px;
        bottom: 10px;
        left: 242px;
        right: 0px;
        flex: 1;
        padding: 20px 0;
        box-sizing: border-box;
        overflow-y: hidden;
    }
}
</style>
